import { BooleanOperators, DateOperators, EnumOperators, NumberOperators, StringOperators } from '@shared/enums';

export const filterOperatorMap = new Map<
  'string' | 'number' | 'date' | 'boolean' | 'enum',
  Record<string, (objectValue: any, filterValue: any) => any>
>([
  [
    'string',
    {
      [StringOperators.EQUALS]: (objectValue: string, filterValue: string) =>
        objectValue.toLowerCase().trim() === filterValue.toLowerCase().trim(),
      [StringOperators.CONTAINS]: (objectValue: string, filterValue: string) =>
        objectValue.toLowerCase().trim().includes(filterValue.toLowerCase().trim()),
      [StringOperators.DOES_NOT_CONTAIN]: (objectValue: string, filterValue: string) =>
        !objectValue.toLowerCase().trim().includes(filterValue.toLowerCase().trim()),
      [StringOperators.STARTS_WITH]: (objectValue: string, filterValue: string) =>
        objectValue.toLowerCase().trim().startsWith(filterValue.toLowerCase().trim()),
      [StringOperators.ENDS_WITH]: (objectValue: string, filterValue: string) =>
        objectValue.toLowerCase().trim().endsWith(filterValue.toLowerCase().trim()),
      [StringOperators.IS_EMPTY]: (objectValue: string) => objectValue.trim().length === 0,
      [StringOperators.IS_NOT_EMPTY]: (objectValue: string) => objectValue.trim().length > 0,
    },
  ],
  [
    'number',
    {
      [NumberOperators.EQUALS]: (objectValue: number, filterValue: number) => objectValue === filterValue,
      [NumberOperators.GREATER_THAN]: (objectValue: number, filterValue: number) => objectValue > filterValue,
      [NumberOperators.LESS_THAN]: (objectValue: number, filterValue: number) => objectValue < filterValue,
      [NumberOperators.GREATER_THAN_OR_EQUAL]: (objectValue: number, filterValue: number) => objectValue >= filterValue,
      [NumberOperators.LESS_THAN_OR_EQUAL]: (objectValue: number, filterValue: number) => objectValue <= filterValue,
      [NumberOperators.IS_EMPTY]: (objectValue: number) => objectValue === null || objectValue === undefined,
      [NumberOperators.IS_NOT_EMPTY]: (objectValue: number) => objectValue !== null && objectValue !== undefined,
      [NumberOperators.ZERO]: (objectValue: number) => objectValue === 0,
    },
  ],
  [
    'date',
    {
      [DateOperators.EQUALS]: (objectValue: Date, filterValue: Date) =>
        new Date(objectValue).getTime() === filterValue.getTime(),
      [DateOperators.AFTER]: (objectValue: Date, filterValue: Date) =>
        new Date(objectValue).getTime() > filterValue.getTime(),
      [DateOperators.BEFORE]: (objectValue: Date, filterValue: Date) =>
        new Date(objectValue).getTime() < filterValue.getTime(),
      [DateOperators.IS_EMPTY]: (objectValue: Date) => objectValue === null || objectValue === undefined,
      [DateOperators.IS_NOT_EMPTY]: (objectValue: Date) => objectValue !== null && objectValue !== undefined,
    },
  ],
  [
    'boolean',
    {
      [BooleanOperators.IS_TRUE]: (objectValue: boolean) => objectValue === true,
      [BooleanOperators.IS_FALSE]: (objectValue: boolean) => objectValue === false,
      [BooleanOperators.IS_EMPTY]: (objectValue: boolean) => objectValue === null || objectValue === undefined,
      [BooleanOperators.IS_NOT_EMPTY]: (objectValue: boolean) => objectValue !== null && objectValue !== undefined,
    },
  ],
  [
    'enum',
    {
      [EnumOperators.EQUALS]: (objectValue: string, filterValue: string) => objectValue === filterValue,
      [EnumOperators.SOME]: (objectValue: string | number, filterValue: (string | number)[]) =>
        filterValue.includes(objectValue),
      [EnumOperators.NOT_EQUALS]: (objectValue: string, filterValue: string) => objectValue !== filterValue,
      [EnumOperators.IS_EMPTY]: (objectValue: string) =>
        objectValue === null || objectValue === undefined || objectValue === '',
      [EnumOperators.IS_NOT_EMPTY]: (objectValue: string) =>
        objectValue !== null && objectValue !== undefined && objectValue !== '',
    },
  ],
]);
